module.exports = __webpack_public_path__ + "static/img/zgzl.353b215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/data/agency/zgzl.jpg
// module id = PCMG
// module chunks = 1